import { render } from "./InvoiceProfileSearchModal.vue?vue&type=template&id=6b5b3398"
import script from "./InvoiceProfileSearchModal.vue?vue&type=script&lang=js"
export * from "./InvoiceProfileSearchModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__